export default {
  EAT_FIGHTER: 'fighter',
  EAT_SHOOTER: 'shooter',
  EAT_PARACHUTES: 'parachutes',
  EAT_BG_JETS: 'bg_jets',
}
